import cx from 'classnames';
import { node, func, string, arrayOf, oneOfType } from 'prop-types';
import React, { Children, Fragment } from 'react';
import { Shelf, Stack } from '../../Layout/index';
import Divider from '../../Divider/index';
import useMedia from '../../../hooks/useMedia';
import Select from '../../Select/index';
import ColorMap from '../../../mixins/colorMap';
import useControlProp from '../../../hooks/useControlProp';
import style from './Tabbing.module.scss';

const Tabbing = ({ children, selectedColor = "Orange", space = "small", tab, onChange, defaultTab, ...rest }) => {
  const isMobile = useMedia('(max-width: 600px)');
  // eslint-disable-next-line no-shadow
  const tabItems = Children.toArray(children).map(({ props: { name, children } }) => ({
    name,
    children,
  }));

  const [tabState, setCurrentTab] = useControlProp(tab, onChange, defaultTab);
  const currentTab = tabItems.find(t => t.name === tabState)?.name ?? tabItems[0].name;
  const showDropdown = isMobile && tabItems.length > 2;

  return (
    <Fragment>
      <Stack gap={space} {...rest}>
        {showDropdown ? (
          <Select
            value={currentTab}
            onChange={({ target }) => setCurrentTab(target.value)}
            className={style.select}
          >
            {tabItems.map(({ name }) => (
              <option value={name} key={name}>
                {name}
              </option>
            ))}
          </Select>
        ) : (
            <div>
              <Shelf gap="xxsmall">
                {tabItems.map(({ name }) => (
                  <div className={style.navItems} key={name} onClick={() => setCurrentTab(name)}>
                    <button
                      type="button"
                      className={cx(
                        style.tab,
                        currentTab === name &&
                        style.checked
                      )}
                      style={{
                        borderBottom: currentTab === name && `2px solid ${ColorMap[selectedColor]}`,
                      }}
                    >
                      {name}
                    </button>
                  </div>
                ))}
              </Shelf>
              <Divider mt="-1px" />
            </div>
          )}
        <div>
          {tabItems.find(({ name }) => name === currentTab).children}
        </div>
      </Stack>
    </Fragment>
  );
};

export default Tabbing;

Tabbing.propTypes = {
  children: oneOfType([arrayOf(node), node]).isRequired,
  selectedColor: string,
  space: string,
  tab: string,
  onChange: func,
  defaultTab: string,
};
